module.exports = __webpack_public_path__ + "static/img/22b.5336722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/22b.png
// module id = 3Nm6
// module chunks = 1